<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <div class="col-12">
    <div>
      <section-title class="mt-3" content="Documento" :has-line="true" />
      <validation-observer ref="interventionPlanDocument">
        <intervention-plan-document
          :data="localDocument"
          :document-saved="isDocumentSaved"
          :document-type-id="documentTypeId"
          @edit-document="editDocumentHandler"
          @save-document="saveDocumentHandler"
        />
      </validation-observer>
      <div v-if="hasAllRequiredFields === false">
        <custom-error
          message="Documento adjuntado no corresponde al Plan de Intervención USQRP"
        />
      </div>
    </div>
    <div>
      <section-title
        class="mt-3"
        content="Firmas del Participante"
        :has-line="true"
      />
      <div class="pt-2">
        <div
          v-for="(row, index) of participants"
          v-if="!row.isProvider && row.relationTypeId != null"
          :key="`signaturesprovider-item-${index}`"
          class="result-table pt-2"
        >
          <div class="row pt-2 col-12 align-items-center">
            <div class="col-md-1 text-left">
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-radio-button
                  :ref="`primarySigner-${index}`"
                  v-model="row.isPrimary"
                  custom-error-msg="Firmante es requerido."
                  :error="errors[0]"
                  :is-disabled="false"
                  is-inline
                  :name="`firmante`"
                  :options="
                    row.id > 0
                      ? [
                          {
                            value: row.isPrimary ? true : index,
                          },
                        ]
                      : [
                          {
                            value: row.isPrimary ? true : index,
                          },
                        ]
                  "
                  @input="changePrimarySigner(index)"
                />
              </validation-provider>
            </div>
            <div class="col-md-3">
              <div class="color-gray-6 font-14">Nombre del Firmante:</div>
              <div class="color-black font-16 bold">
                {{ row.participantFullName }}
              </div>
            </div>
            <div class="col-md-2">
              <div class="color-gray-6 font-14">Parentesco:</div>
              <div class="color-black font-16 bold">
                {{ getRelationshipName(row.relationTypeId) }}
              </div>
            </div>
            <div class="col-md-3">
              <div class="color-gray-6 font-14">Correo Electrónico:</div>
              <div class="color-black font-16 bold">
                {{ row.email }}
                {{ row.userName && '/ ' + row.userName }}
              </div>
            </div>
            <div class="col-md-2">
              <div class="color-gray-6 font-14">Número de Teléfono:</div>
              <div class="color-black font-16 bold">
                {{ row.phone | phone }}
              </div>
            </div>
            <div class="col-md-1 pt-2 text-right">
              <action-button
                v-if="row.userId == null"
                class="btn-action-size-cancel"
                i="fas fa-times-circle"
                variant="outline-danger btn-cancel danger"
                @click="() => onDelete(row.id, index)"
              />
            </div>
          </div>
        </div>
      </div>
      <div v-if="isEdit()" id="SignaturesContractorRef" class="pt-3">
        <ValidationObserver
          ref="SignaturesContractorRef"
          v-slot="{}"
          tag="form"
        >
          <div class="result-table">
            <div class="row py-3 mr-md-0 col-12">
              <div class="row pt-2 col-12" style="padding-right: 0px;">
                <div class="col-md-3">
                  <div class="color-gray-6 font-14">
                    Nombre del Firmante:
                  </div>
                  <div class="color-black font-16 bold">
                    <validation-provider
                      ref="participantFullName"
                      v-slot="{ errors }"
                      name="participantFullName"
                      :rules="'required'"
                    >
                      <custom-input
                        v-model="model.participantFullName"
                        :custom-error-msg="
                          'El Nombre del Firmante es requerido.'
                        "
                        :error="errors[0]"
                        placeholder="Nombre del Firmante"
                        type="text"
                      />
                    </validation-provider>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="color-gray-6 font-14">Parentesco:</div>

                  <div class="color-black font-16 bold">
                    <validation-provider
                      ref="relationship"
                      v-slot="{ errors }"
                      name="relationship"
                      :rules="'required'"
                    >
                      <custom-drop-down
                        id="relationship"
                        v-model="model.relationtype"
                        :clearable="false"
                        :custom-error-msg="'El Parentesco es requerido.'"
                        :error="errors[0]"
                        fieldkey="id"
                        fieldname="name"
                        :options="relationtypeOptions"
                        placeholder="Seleccione"
                      />
                    </validation-provider>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="color-gray-6 font-14">Correo Electrónico:</div>
                  <div class="color-black font-16 bold">
                    <validation-provider
                      v-slot="{ errors, failedRules }"
                      name="Email"
                      rules="required|email"
                    >
                      <custom-input
                        v-model="model.email"
                        :custom-error-msg="
                          failedRules['email']
                            ? 'El correo electrónico no es válido.'
                            : 'El correo electrónico es requerido.'
                        "
                        :error="errors[0]"
                        placeholder="Correo Electrónico"
                        type="email"
                      />
                    </validation-provider>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="color-gray-6 font-14">Número de Teléfono:</div>
                  <div class="color-black font-16 bold">
                    <validation-provider
                      ref="phone"
                      v-slot="{ errors }"
                      name="phone"
                      :rules="'required'"
                    >
                      <custom-input
                        v-model="model.phone"
                        :custom-error-msg="'El teléfono es requerido.'"
                        :error="errors[0]"
                        :mask-type="'Phone'"
                        placeholder="(___)___-____"
                      />
                    </validation-provider>
                  </div>
                </div>
              </div>
              <div class="row col-md-12 pt-4 button-table">
                <action-button
                  class="btn-action-size ml-2"
                  i="fas fa-times-circle"
                  text="Cancelar"
                  variant="outline-danger btn-cancel danger"
                  @click="() => onCancel()"
                />
                <action-button
                  class="btn-action-size ml-2"
                  i="fas fa-file-plus fa-lg mt-1 mb-1"
                  text="Añadir"
                  variant="success"
                  @click="() => saverequest()"
                />
              </div>
            </div>
          </div>
        </ValidationObserver>
      </div>
    </div>
    <div v-if="isShowButtonAdd()" class="row col-md-12 pt-2 button-table">
      <action-button
        class="btn-action-size ml-2"
        i="fas fa-file-plus fa-lg mt-1 mb-1"
        text="Añadir Participante"
        variant="success mt-2"
        @click="() => onShowEditForm()"
      />
    </div>
  </div>
</template>
<script>
import SectionTitle from 'SectionTitle';
import CustomInput from 'CustomInput';
import CustomError from 'custom-error';
import CustomDropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';
import CustomRadioButton from 'custom-radio';
import { getPeicode as _getPeicode } from '@/services/common/code.api';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import roles from '@/utils/constants/roles.js';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import { getcodeRelationshipNameByCode as _getRelationshipNameByCode } from '@/utils/constants/codeRelationship';
import { deleteSignatureHandwritten as _deleteSignatureHandwritten } from '@/services/uspqrp/signatures-contractor.api';
import objectToFormData from 'object-to-formdata';
import InterventionPlanDocument from './InterventionPlanDocument.vue';
import { validateInterventionPlanDocumentWithAI as _validateInterventionPlanDocumentWithAI } from '@/services/uspqrp/intervention-plan.api.js';
import { getSignatureParticipants as _getSignatureParticipants } from '@/services/uspqrp/intervention-plan.api.js';
import rpContractDocumentTypes from '@/utils/constants/rpContractDocumentTypes.js';

export default {
  name: 'SignatureManuscript',
  components: {
    SectionTitle,
    CustomInput,
    CustomError,
    CustomDropDown,
    ActionButton,
    CustomRadioButton,
    ValidationObserver,
    ValidationProvider,
    InterventionPlanDocument,
  },
  mixins: [alertMixin],
  async mounted() {
    this.initializeDocumentState();

    if (this.contractId != null) {
      await this.getParentsSignatures();
    }
    await this.getCodesByType();

    if (this.shouldAutoEdit) {
      await this.$nextTick();
      this.editDocumentHandler();
    }
  },
  data: () => ({
    model: {
      participantFullName: null,
      relationtype: null,
      email: null,
      phone: null,
      userid: null,
      isPrimary: null,
    },
    showEditForm: false,
    showButtonAdd: false,
    relationtypeOptions: [],
    participants: [],
    pendingSignatures: [],
    relationTypeMap: {},
    document: { file: null },
    hasAllRequiredFields: null,
    localDocument: { name: null, file: null, documentId: null },
    isDocumentSaved: false,
  }),
  props: {
    contractId: {
      type: Number,
      default: 0,
      required: false,
    },
    interventionPlanId: {
      type: Number,
      default: 0,
      required: false,
    },
    documentTypeId: {
      type: Number,
      default: 0,
      required: false,
    },
    studentSieId: {
      type: Number,
      default: 0,
      required: false,
    },
    signatureParticipants: {
      type: Array,
      default: () => [],
      required: false,
    },
    documentSave: {
      type: Object,
      default: () => null,
    },
    documentSaved: {
      type: Boolean,
      default: () => false,
    },
    isAchievementSummary: {
      type: Boolean,
      default: () => false,
    },
    shouldAutoEdit: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {},
  watch: {
    document() {
      this.emitData();
    },
    participants() {
      this.emitData();
    },
    documentSave: {
      handler(newVal) {
        if (newVal && newVal.name) {
          this.localDocument = { ...newVal };
          this.isDocumentSaved = this.documentSaved;
        }
      },
      deep: true,
      immediate: false,
    },
    documentSaved(newVal) {
      if (this.localDocument && this.localDocument.name) {
        this.isDocumentSaved = newVal;
      }
    },
  },
  methods: {
    initializeDocumentState() {
      const hasDocument =
        this.documentSave &&
        (this.documentSave.name || this.documentSave.documentId);

      if (hasDocument) {
        this.localDocument = { ...this.documentSave };
        this.isDocumentSaved = this.documentSaved;
      } else {
        this.localDocument = { name: null, file: null, documentId: null };
        this.isDocumentSaved = false;
      }
    },
    async getCodesByType() {
      const payload = {
        codeType: 'Relationship',
        longName: false,
      };
      this.relationtypeOptions = (await _getPeicode(payload)).data;

      this.relationTypeMap = this.relationtypeOptions.reduce((map, option) => {
        map[option.id] = option.name;
        return map;
      }, {});
    },
    getRelationshipName(code) {
      return _getRelationshipNameByCode(code);
    },
    async getParentsSignatures() {
      this.participants = [];
      this.participants.length = 0;

      const params = {
        isElectronicSignature: false,
        studentSieId: this.studentSieId,
        planId: this.interventionPlanId,
        documentTypeId: this.documentTypeId,
      };
      const parents = (await _getSignatureParticipants(params)).data;

      // Remove teacher from the list of parents
      const index = parents.findIndex(
        (signature) =>
          signature.roleId !== undefined &&
          signature.roleId !== null &&
          signature.roleId.toLowerCase() === roles.Teacher.toLowerCase()
      );

      if (index !== -1) {
        parents.splice(index, 1);
      }

      this.participants = parents;
      this.emitData();
    },
    async onDelete(id, index) {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro(a) de que desea borrar este participante?`,
        'Sí',
        'No'
      );

      if (answer) {
        if (id) {
          await _deleteSignatureHandwritten(id);
          this.participants = this.participants.filter(
            (participant) => participant.id !== id
          );
        } else {
          this.participants.splice(index, 1);

          if (this.pendingSignatures.length > 0) {
            this.pendingSignatures.splice(index - 1, 1);
          }
        }
        await this.getCodesByType();
        this.showEditForm = false;
        this.showButtonAdd = true;
        this.isShowButtonAdd();
      } else {
        return;
      }
    },
    async saverequest() {
      const isValid = await this.$refs.SignaturesContractorRef.validate();
      if (isValid) {
        const newPendingSignature = {
          participantFullName: this.model.participantFullName,
          relationType: this.model.relationtype?.name,
          relationTypeId: this.model.relationtype?.id,
          email: this.model.email,
          phone: this.model.phone,
          userid: this.model?.userid,
          isProvider: false,
          isPrimary: false,
          check: false,
          roleid: null,
        };

        const newSignature = {
          participantFullName: this.model.participantFullName,
          relationType: this.model.relationtype?.name,
          relationTypeId: this.model.relationtype?.id,
          email: this.model.email,
          phone: this.model.phone,
          userid: this.model?.userid,
          isProvider: false,
          isPrimary: false,
          check: false,
        };

        this.pendingSignatures.push(newPendingSignature);
        this.participants.push(newSignature);

        this.emitData();
        await this.getCodesByType();
        this.clearModel();
        this.resetValidation();
        this.showEditForm = false;
      } else {
        this.ShowToast('Alerta', 'Información Incompleta', 'error');
        return;
      }
    },
    editDocumentHandler() {
      this.isDocumentSaved = false;
      this.localDocument = { name: null, file: null, documentId: null };
    },
    onCancel() {
      this.showEditForm = false;
      this.showButtonAdd == true;
      this.isShowButtonAdd();
      this.isEdit();
      this.clearModel();
    },
    async clearModel() {
      this.model = {
        participantFullName: null,
        relationtype: null,
        email: null,
        phone: null,
      };
    },
    isShowButtonAdd() {
      var result = false;

      if (this.pendingSignatures.length < 1 && !this.showEditForm) {
        result = true;
      }
      return result;
    },
    onShowEditForm() {
      this.showEditForm = true;
      this.showButtonAdd = false;
    },
    resetValidation() {
      this.$refs.SignaturesContractorRef.reset();
    },
    changePrimarySigner(index) {
      this.participants = this.participants.map((participant, i) => {
        return {
          ...participant,
          isPrimary: i === index,
        };
      });
      this.emitData();
    },
    isEdit() {
      if (this.participants.length <= 1 && this.showEditForm) {
        return true;
      }
      return false;
    },
    async saveDocumentHandler(document) {
      if (document != null) {
        this.document.file = document;
        this.document.name = document.name;
        this.document.documentId = null;

        const payloadDocument = {
          document: this.document,
        };
        const params = objectToFormData(
          { ...payloadDocument },
          { indices: true, nullsAsUndefineds: true }
        );

        if (this.document && this.document.file && !this.document.documentId) {
          params.append(
            `document`,
            this.document.file,
            this.document.file.name
          );
        }

        await _validateInterventionPlanDocumentWithAI(
          params,
          this.isAchievementSummary
            ? rpContractDocumentTypes.ProgressReport
            : rpContractDocumentTypes.InterventionPlan
        )
          .then((res) => {
            this.hasAllRequiredFields = res.data;

            if (this.hasAllRequiredFields) {
              this.localDocument = {
                name: document.name,
                file: document,
                documentId: null,
              };
              this.isDocumentSaved = true;
              this.ShowToast(
                'Confirmación',
                `El documento ha sido validado exitosamente.`,
                'success'
              );
            } else {
              this.document.file = null;
              this.document.name = null;
              this.document.documentId = null;
              this.document = { file: null };
              this.localDocument = { name: null, file: null, documentId: null };
              this.isDocumentSaved = false;

              this.ShowToast(
                'Confirmación',
                `El documento no es valido.`,
                'error'
              );
            }
            this.emitData();
          })
          .catch(() =>
            this.ShowToast('Alerta', 'Ha ocurrido un error.', 'error')
          );
      } else {
        this.noMatchLabels = [];
      }
    },
    emitData() {
      this.$emit('update-manuscript', {
        document: this.document,
        participants: this.participants,
      });
    },
  },
};
</script>
<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';
.result-table {
  padding-left: 20px;
  background-color: #f7f7f7;
  border-bottom: 1px solid darkgray;
  padding-bottom: 20px;
}
.row-message {
  border: 1px solid #f3af54;
  margin-bottom: 0px !important;
}
.button-table {
  justify-content: flex-end !important;
  float: right !important;
}
.mr-0 {
  padding-left: 16px !important;
}
.btn-action-size {
  width: auto !important;
}
.btn-action-size-cancel {
  width: 40px;
  height: 40px;
}
.row-message {
  border: 1px solid #f3af54;
  margin-bottom: 0px !important;
}

::v-deep input[type='checkbox'] + label span {
  background-color: white;
}
</style>
